<template>
  <div id="am-info-tab">
    <h2 class="main-title" v-html="info.title" />
    <div style="width: 100% !important">
      <ul class="nav nav-tabs">
        <li class="active">
          <a>Info</a>
        </li>
        <li v-if="info.is_full_video_visible">
          <a href="#aw-fw">Full Video</a>
        </li>
      </ul>
    </div>
    <div class="tab-content" id="nav-tabContent" style="width: 100% !important">
      <div v-html="info.description" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { WebinarInfo } from "@/models/WebinarInfo"

import "@/assets/infoTab.css"

export default defineComponent({
  props: {
    info: Object as PropType<WebinarInfo>
  }
})
</script>
